export const getBaseApi = () => {
  return process.env.REACT_APP_BASE_URL || "https://teams-api.listingcopy.ai/";
};
